import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import DataTableExtensions from "react-data-table-component-extensions";
import DataTable from "react-data-table-component";
import Loader from "../../../components/shared/Loader";
import { updateMeta } from "../../../store/actions/metaAction";
import { useDispatch } from "react-redux";

const HeaderIndex = () => {
	const [slides, setSlides] = useState([]);
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اقسام الموقع",
				breadcrumb: "اقسام الموقع",
				button: {
					show: false,
					text: null,
					link: null,
					// show: true,
					// text: "اضافة معلومة جديد",
					// link: "/aboutPage/header/create",
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/pages/site-infos`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setSlides(response.data.data.page.sections);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const columns = [
		// {
		// 	name: "الصورة",
		// 	sortable: true,
		// 	cell: row => {
		// 		return (
		// 			<img
		// 				style={{ maxHeight: "100px", maxWidth: "200px" }}
		// 				src={process.env.REACT_APP_MAIN_URL + row.data.image}
		// 				alt={row.data.title.ar}
		// 			/>
		// 		);
		// 	},
		// },
		{
			name: "الاسم",
			sortable: true,
			cell: row => {
				return row.titleObj.ar;
			},
		},
		{
			name: "",
			selector: "settings",
			cell: row => (
				<ul className="list-inline settingsList">
					<li className="list-inline-item">
						<Link
							className="bt bt-sm bt-success"
							to={`/siteinfo/show/${row.slug}`}
						>
							<i className="fas fa-edit"></i>
						</Link>
					</li>
				</ul>
			),
		},
	];

	const handleConfirmDelete = headerId => {
		confirmAlert({
			title: "تأكيد الحذف",
			message: "هل أنت متأكد من رغبتك في الحذف؟",
			buttons: [
				{
					label: "نعم",
					onClick: () => deleteSlide(headerId),
				},
				{
					label: "لا",
					onClick: () => console.log("No"),
				},
			],
		});
	};

	const deleteSlide = headerId => {
		axios
			.delete(`${process.env.REACT_APP_API_URL}/posts/${headerId}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				onStart();
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<div className="datatable">
				<DataTableExtensions columns={columns} data={slides}>
					<DataTable
						noHeader
						defaultSortField="id"
						defaultSortAsc={false}
						pagination
						highlightOnHover
						direction="rtl"
						striped
					/>
				</DataTableExtensions>
			</div>
		</section>
	);
};

export default HeaderIndex;
